import { FunctionComponent, useEffect, useState } from "react";
import {
  LoadingSpinner,
  PageContainer,
  PageTitle,
} from "src/components/generic";
import { useLocation, Link, useParams } from "react-router-dom";
import SubscriberRegistrationForm from "src/components/forms/auth/SubscriberRegistrationForm";
import TopNav from "src/components/navigation/TopNav";
import SubscriptionPayment from "src/components/forms/stripe/SubscriptionPayment";
import { stripe } from "src/utils";
import { capitalizeFirstLetter } from "src/utils/format/strings";
import { EnterpriseTier, extractEnterpriseProductInclusions, extractEnterpriseProductPrice, extractEnterpriseProductPriceId, isEnterpriseTier } from "src/utils/pricing";
import ReferralPartnerRegistrationForm from "src/components/forms/auth/ReferralPartnerRegistrationForm";

const SubscriberRegistration: FunctionComponent = () => {
  const prod = process.env.REACT_APP_ENV === "prod";

  // Extract subscription tier from URL and convert it to EnterpriseTier type
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const tier: string | null = queryParams.get("tier");
  const enterpriseTier: EnterpriseTier | null = tier && isEnterpriseTier(tier) ? tier : null;
  const currentSelectedTier: EnterpriseTier = enterpriseTier ?? "gold" as EnterpriseTier;

  // Extract subscription details
  const priceId = extractEnterpriseProductPriceId(prod, currentSelectedTier);
  const firstPaymentAmount = extractEnterpriseProductPrice(currentSelectedTier);
  const included = extractEnterpriseProductInclusions(currentSelectedTier);
  const planName = `${capitalizeFirstLetter(tier || "Premium")} Plan`;

  const [hasSubscribed, setHasSubscribed] = useState<boolean>(false);
  const [customerId, setCustomerId] = useState<string | null>(null);

  const createGuestId = async () => {
    try {
      const result = await stripe.payments.createCreateGuestCustomer();

      setCustomerId(result?.customerId);
    } catch (error) {
      console.log({ error });
    }
  };

  useEffect(() => {
    if (!customerId) createGuestId();
  }, []);

  if (!customerId) return <LoadingSpinner />;

  return (
    <PageContainer>
      <div className="px-3">
        <TopNav />
      </div>

      <div>
        <PageTitle title="Subscriber Registration" />

        {hasSubscribed ? (
          currentSelectedTier === "copper" ? <ReferralPartnerRegistrationForm /> :
           <SubscriberRegistrationForm customerId={customerId} currentSelectedTier={currentSelectedTier} />
        ) : (
          <SubscriptionPayment
            customerId={customerId}
            priceId={priceId}
            planName={planName}
            billingCycle={"Monthly"}
            firstPaymentAmount={firstPaymentAmount}
            included={included}
            onSubscriptionComplete={() => setHasSubscribed(true)}
          />
        )}
      </div>

      <div className="flex flex-col mt-8">
        <Link to="/auth/login" className="text-primary self-center mb-4">
          Already Have Account?
        </Link>
      </div>
    </PageContainer>
  );
};

export default SubscriberRegistration;
